module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon_bangdan.f8608.png";